var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-content__item-page ui-alert ui-item-page" },
    [
      _c("h2", { staticClass: "ui-item-page__title" }, [_vm._v("UI Alert")]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-1" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Basic"),
              ]),
              _c(
                "vue-checkbox",
                {
                  model: {
                    value: _vm.checked,
                    callback: function ($$v) {
                      _vm.checked = $$v
                    },
                    expression: "checked",
                  },
                },
                [_vm._v("Option")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-2" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Disabled State"),
              ]),
              _c(
                "vue-checkbox",
                {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.checked1,
                    callback: function ($$v) {
                      _vm.checked1 = $$v
                    },
                    expression: "checked1",
                  },
                },
                [_vm._v("Option")]
              ),
              _c(
                "vue-checkbox",
                {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.checked2,
                    callback: function ($$v) {
                      _vm.checked2 = $$v
                    },
                    expression: "checked2",
                  },
                },
                [_vm._v("Option")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-5" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Checkbox group"),
              ]),
              _c(
                "vue-checkbox-group",
                {
                  model: {
                    value: _vm.checkList,
                    callback: function ($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList",
                  },
                },
                [
                  _c("vue-checkbox", { attrs: { label: "Option A" } }),
                  _c("vue-checkbox", { attrs: { label: "Option B" } }),
                  _c("vue-checkbox", { attrs: { label: "Option C" } }),
                  _c("vue-checkbox", {
                    attrs: { label: "disabled", disabled: "" },
                  }),
                  _c("vue-checkbox", {
                    attrs: { label: "selected and disabled", disabled: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-4" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Indeterminate"),
              ]),
              _c(
                "vue-checkbox",
                {
                  attrs: { indeterminate: _vm.isIndeterminate },
                  on: { change: _vm.handleCheckAllChange },
                  model: {
                    value: _vm.checkAll,
                    callback: function ($$v) {
                      _vm.checkAll = $$v
                    },
                    expression: "checkAll",
                  },
                },
                [_vm._v("Check all")]
              ),
              _c("div", { staticStyle: { margin: "15px 0" } }),
              _c(
                "vue-checkbox-group",
                {
                  on: { change: _vm.handleCheckedCitiesChange },
                  model: {
                    value: _vm.checkedCities,
                    callback: function ($$v) {
                      _vm.checkedCities = $$v
                    },
                    expression: "checkedCities",
                  },
                },
                _vm._l(_vm.cities, function (city) {
                  return _c(
                    "vue-checkbox",
                    { key: city, attrs: { label: city } },
                    [_vm._v(_vm._s(city))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Minimum / Maximum items checked"),
              ]),
              _c(
                "vue-checkbox-group",
                {
                  attrs: { min: 1, max: 2 },
                  model: {
                    value: _vm.checkedCities1,
                    callback: function ($$v) {
                      _vm.checkedCities1 = $$v
                    },
                    expression: "checkedCities1",
                  },
                },
                _vm._l(_vm.cities, function (city) {
                  return _c(
                    "vue-checkbox",
                    { key: city, attrs: { label: city } },
                    [_vm._v(_vm._s(city))]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-4" }, [
            _c("h5", { staticClass: "ui-item-page__sub-title" }, [
              _vm._v("Button style"),
            ]),
            _c(
              "div",
              [
                _c(
                  "vue-checkbox-group",
                  {
                    model: {
                      value: _vm.checkboxGroup1,
                      callback: function ($$v) {
                        _vm.checkboxGroup1 = $$v
                      },
                      expression: "checkboxGroup1",
                    },
                  },
                  _vm._l(_vm.cities, function (city) {
                    return _c(
                      "vue-checkbox-button",
                      { key: city, attrs: { label: city } },
                      [_vm._v(_vm._s(city))]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "vue-checkbox-group",
                      {
                        attrs: { size: "medium" },
                        model: {
                          value: _vm.checkboxGroup2,
                          callback: function ($$v) {
                            _vm.checkboxGroup2 = $$v
                          },
                          expression: "checkboxGroup2",
                        },
                      },
                      _vm._l(_vm.cities, function (city) {
                        return _c(
                          "vue-checkbox-button",
                          { key: city, attrs: { label: city } },
                          [_vm._v(_vm._s(city))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "vue-checkbox-group",
                      {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.checkboxGroup3,
                          callback: function ($$v) {
                            _vm.checkboxGroup3 = $$v
                          },
                          expression: "checkboxGroup3",
                        },
                      },
                      _vm._l(_vm.cities, function (city) {
                        return _c(
                          "vue-checkbox-button",
                          {
                            key: city,
                            attrs: {
                              label: city,
                              disabled: city === "Beijing",
                            },
                          },
                          [_vm._v(_vm._s(city))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "vue-checkbox-group",
                      {
                        attrs: { size: "mini", disabled: "" },
                        model: {
                          value: _vm.checkboxGroup4,
                          callback: function ($$v) {
                            _vm.checkboxGroup4 = $$v
                          },
                          expression: "checkboxGroup4",
                        },
                      },
                      _vm._l(_vm.cities, function (city) {
                        return _c(
                          "vue-checkbox-button",
                          { key: city, attrs: { label: city } },
                          [_vm._v(_vm._s(city))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "col-lg-4" }, [
            _c("h5", { staticClass: "ui-item-page__sub-title" }, [
              _vm._v("Button style With borders"),
            ]),
            _c(
              "div",
              [
                _c("vue-checkbox", {
                  attrs: { label: "Option1", border: "" },
                  model: {
                    value: _vm.checked3,
                    callback: function ($$v) {
                      _vm.checked3 = $$v
                    },
                    expression: "checked3",
                  },
                }),
                _c("vue-checkbox", {
                  attrs: { label: "Option2", border: "" },
                  model: {
                    value: _vm.checked4,
                    callback: function ($$v) {
                      _vm.checked4 = $$v
                    },
                    expression: "checked4",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c("vue-checkbox", {
                  attrs: { label: "Option1", border: "", size: "medium" },
                  model: {
                    value: _vm.checked5,
                    callback: function ($$v) {
                      _vm.checked5 = $$v
                    },
                    expression: "checked5",
                  },
                }),
                _c("vue-checkbox", {
                  attrs: { label: "Option2", border: "", size: "medium" },
                  model: {
                    value: _vm.checked6,
                    callback: function ($$v) {
                      _vm.checked6 = $$v
                    },
                    expression: "checked6",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "vue-checkbox-group",
                  {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.checkboxGroup5,
                      callback: function ($$v) {
                        _vm.checkboxGroup5 = $$v
                      },
                      expression: "checkboxGroup5",
                    },
                  },
                  [
                    _c("vue-checkbox", {
                      attrs: { label: "Option1", border: "" },
                    }),
                    _c("vue-checkbox", {
                      attrs: { label: "Option2", border: "", disabled: "" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "vue-checkbox-group",
                  {
                    attrs: { size: "mini", disabled: "" },
                    model: {
                      value: _vm.checkboxGroup6,
                      callback: function ($$v) {
                        _vm.checkboxGroup6 = $$v
                      },
                      expression: "checkboxGroup6",
                    },
                  },
                  [
                    _c("vue-checkbox", {
                      attrs: { label: "Option1", border: "" },
                    }),
                    _c("vue-checkbox", {
                      attrs: { label: "Option2", border: "" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }